import { ImageTemplate } from "../template";
import { ImageProps } from "..";
import ParachuteLogoWithText1x from "./parachute-logo-with-text-1x.png";
import ParachuteLogoWithText2x from "./parachute-logo-with-text-2x.png";
import ParachuteLogoWithText4x from "./parachute-logo-with-text-4x.png";

export const ParachuteLogoWithTextImage = ({
  width,
  height,
  highResolution,
  ...props
}: ImageProps): JSX.Element => {
  return (
    <div style={{ height, width }}>
      <ImageTemplate
        {...props}
        imgSrc={ParachuteLogoWithText4x}
      />
    </div>
  );
};